export const taskList1 = [
  { id: 'one', content: "Read bible" },
  { id: 'jdd', content: "Do an hour worship" },
  { id: 'dws', content: "Do quiet time" },
  { id: 'whe', content: "Surf the internet" },
  { id: 'dqaw', content: "Review codes and debug" },
  { id: 'awaer', content: "Read a book" },
  { id: 'wqwe', content: "Write an article" },

];
export const taskList2 = [
  { id: 'faef', content: "Build chatscrum" },
  { id: 'dfe', content: "Build trello app" },
  { id: 'are', content: "Go shopping" },
  { id:'afea', content: "Surf the internet" },
  { id: 'afe', content: "Sleep all night" },
  { id: 'art', content: "Read a book" },
  { id: 'oet', content: "Play call to duty" },

];


// export const taskList2 = {
//   items: [
//     { id: 1, item: "build chatscrum" },
//     { id: 2, item: "build trello app" },
//     { id: 3, item: "go shopping" },
//     { id: 4, item: "sleep all night" },
//     { id: 5, item: "play call a duty" },
//   ],
// };


